export const CAREER_GOALS = [
  'get_promoted',
  'grow_in_career',
  'change_career_path',
  'start_first_career',
  'academic_goals',
] as const;

export type CareerGoal = (typeof CAREER_GOALS)[number];

export interface CareerPreference {
  id: string;
  career_goal: CareerGoal | null;
  current_job_title_id: number | null;
  target_job_title_id: number | null;
  current_job: string | null;
  target_job: string | null;
  field_of_study: string | null;
  created_at: string;
  updated_at: string;
}

export interface CareerPreferenceUpdatePayload {
  career_preference: {
    career_goal: CareerGoal;
    current_job_title_id?: number;
    target_job_title_id?: number;
    field_of_study?: string;
  };
}

export interface SetYourGoalPayload {
  goalId: CareerGoal;
  currentJobTitleId?: number;
  targetJobTitleId?: number;
  fieldOfStudy?: string;
}
